import { jsx as _jsx } from "react/jsx-runtime";
import ExtraInfoDetails from './details';
import ExtraInfoSkeleton from './skeleton';
var ExtraInfo = function (_a) {
    var accountId = _a.accountId, config = _a.config, currentTransaction = _a.currentTransaction, type = _a.type;
    return (_jsx(ExtraInfoSkeleton, { currentTransaction: currentTransaction, type: type, children: _jsx(ExtraInfoDetails, { accountId: accountId, config: config, currentTransaction: currentTransaction, type: type }) }));
};
export default ExtraInfo;
//# sourceMappingURL=index.js.map